/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

/* Options */
import countriesBuild from 'src/preval/countries.preval'
import { sanitizeCountries } from 'src/functions/countriesFallback'

import { tcouponFrontend } from 'src/shared/frontendTypes/coupon'

const countries = sanitizeCountries(countriesBuild.countries)

const Redux = () => {

  const items = useSelector(store => store.Warenkorb.items)
  const coupon = useSelector(store => store.Warenkorb.coupon)           // String
  const couponObjekt = useSelector(store => store.Warenkorb.couponObjekt) // Vollständiges Objekt

  const shippingCountryIso = useSelector(store => store.Kasse.shippingAdress.land)
  const shippingCountry = countries.find(({iso}) => iso === shippingCountryIso)

  const dispatch = useDispatch()

  const changeQty = (key: string, qty: number) =>
    dispatch({ type: 'qtyWarenkorbItem', payload: { key, qty } })

  const deleteItem = (key: string) =>
    dispatch({ type: 'removeWarenkorbItem', payload: key })

  const applyCoupon = (couponCode: string | null, couponObj?: tcouponFrontend | null) => {
    dispatch({
      type: 'applyCoupon',
      payload: {
        coupon: couponCode,
        couponObjekt: couponObj || null,
      },
    })
  }

  return { items, changeQty, deleteItem, shippingCountry, coupon, couponObjekt, applyCoupon }
}

export default Redux
